import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import AchRelationship from 'Components/AdvisorApp/Viewport/ApexAdminPortal/AccountDetails/AchRelationship';
import Transfers from 'Components/AdvisorApp/Viewport/ApexAdminPortal/AccountDetails/Transfers';
import Profiles from 'Components/AdvisorApp/Viewport/ApexAdminPortal/AccountDetails/Profiles';
import RequestedDocuments from 'Components/AdvisorApp/Viewport/ApexAdminPortal/AccountDetails/RequestedDocuments';
import Investigation from './Investigation';
import History from './History';
import Files from './Files';
import Appeal from './Appeal';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
  bottomButtons: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
  leftButton: {
    marginLeft: theme.spacing(4),
  },
});

const View = ({ classes }) => {
  return (
    <Box className={classes.root}>
      <Investigation />
      <AchRelationship />
      <Profiles />
      <History />
      <Transfers />
      <RequestedDocuments />
      <Files />
      <Appeal />
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(View);
